.pwa-install-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(90deg, #1f2327 0%, #2a3036 100%);
  border-bottom: 2px solid #fdcc00;
  padding: 10px 16px;
  color: #ffffff;
  font-size: 13px;
  position: relative;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

  &__content {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
  }

  &__icon {
    font-size: 20px;
    color: #fdcc00;
  }

  &__text {
    strong {
      color: #fdcc00;
      display: block;
      font-family: "Gotham-Bold", sans-serif;
      font-size: 13px;
      margin-bottom: 2px;
    }
    span {
      color: #d1d5db;
      font-size: 12px;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 12px;
  }

  &__btn {
    background-color: #fdcc00;
    color: #000000;
    border: none;
    border-radius: 20px;
    padding: 6px 14px;
    font-size: 12px;
    font-family: "Gotham-Bold", sans-serif;
    cursor: pointer;
    white-space: nowrap;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #e5b800;
    }
  }

  &__close {
    background: transparent;
    border: none;
    color: #9ca3af;
    font-size: 18px;
    cursor: pointer;
    padding: 4px 8px;

    &:hover {
      color: #ffffff;
    }
  }
}

.pwa-ios-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.pwa-ios-modal {
  background: #24292e;
  border: 1px solid #444d56;
  border-radius: 12px;
  max-width: 420px;
  width: 100%;
  padding: 24px;
  color: #ffffff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    border-bottom: 1px solid #3f4448;
    padding-bottom: 12px;

    h4 {
      margin: 0;
      color: #fdcc00;
      font-family: "Gotham-Bold", sans-serif;
      font-size: 16px;
    }
  }

  &__steps {
    list-style: none;
    padding: 0;
    margin: 16px 0;

    li {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      font-size: 14px;
      line-height: 1.4;
      color: #e1e4e8;

      .step-number {
        background-color: #fdcc00;
        color: #000000;
        font-family: "Gotham-Bold", sans-serif;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        margin-right: 12px;
        flex-shrink: 0;
      }

      .step-text {
        strong {
          color: #fdcc00;
        }
      }
    }
  }

  &__footer {
    text-align: right;
    margin-top: 20px;

    button {
      background-color: #fdcc00;
      color: #000000;
      border: none;
      border-radius: 6px;
      padding: 8px 18px;
      font-family: "Gotham-Bold", sans-serif;
      cursor: pointer;

      &:hover {
        background-color: #e5b800;
      }
    }
  }
}
